import type { IFindSearchResultItem } from './find-search-result-item.model';

export class SearchResultItemApiModel {
  public section!: string;
  public text!: string;
  public title!: string;
  public url!: string;

  public static mapToBusinessModel(apiModel: SearchResultItemApiModel): IFindSearchResultItem {
    return { section: apiModel.section, text: apiModel.text, title: apiModel.title, url: apiModel.url };
  }
}
